if (document.getElementById('page-storeRecruit')) {
  page()
}

function page() {
  //   ####  ##   ##  #####   ####  ##  ##             #####   #####   #####  ##     ##
  //  ##     ##   ##  ##     ##     ## ##             ##   ##  ##  ##  ##     ####   ##
  //  ##     #######  #####  ##     ####    ########  ##   ##  #####   #####  ##  ## ##
  //  ##     ##   ##  ##     ##     ## ##             ##   ##  ##      ##     ##    ###
  //   ####  ##   ##  #####   ####  ##  ##             #####   ##      #####  ##     ##
  /*
  チェック状態に応じて何かを開閉する
  */
  applyCheckOpen()

  window.addEventListener('change', function (e) {
    applyCheckOpen()
  })

  function applyCheckOpen() {
    const checkOpenList = document.getElementsByClassName('js-checkOpen')
    for (const checkOpen of checkOpenList) {
      const targetName = checkOpen.dataset.checkOpen

      console.log(checkOpen.checked)

      const targetList = document.getElementsByClassName('js-checkOpen--' + targetName)

      if (checkOpen.checked) {
        for (const target of targetList) {
          target.style.display = ''
        }
      } else {
        for (const target of targetList) {
          target.style.display = 'none'
        }
      }
    }
  }
}
